<script>
// [VERIFY-3b] Extraído de `chat-message.vue` (646 linhas — não é regra HARD
// como `view-chat.vue`, mas coube numa extração segura: só 1 teste em
// `chat-message.unit.js` tocava os internos daqui, `itensPlanoDecorados`).
// Modo Agente (spec-002, US-10/US-13, wireframe W4) — plano do turno,
// colapsável, nasce aberta; nunca fecha sozinha (regra do DS: seção
// colapsável nunca nasce fechada). Some sozinho quando `itens` vem vazio
// (`v-if` na raiz) — o pai não precisa gatear a renderização.
import { STATUS_DO_PASSO, etapasDoPlano } from '@modules/aawz-intelligence-v2/utils/progresso-do-turno'
import { assinaturaDePlano, itensEncenados } from '@modules/aawz-intelligence-v2/utils/encenacao-do-progresso'
import { encenacaoDoPlano, reveladosDe } from '@modules/aawz-intelligence-v2/utils/encenacao-do-plano'
import { PLANO_DO_TURNO } from '@modules/aawz-intelligence-v2/constants/TextChat'
import PainelSecaoProgresso from '@modules/aawz-intelligence-v2/components/painel-do-chat/painel-secao-progresso.vue'

// Mesmo desenho do Progresso do painel para bolha e aside lerem igual; quem desenha é `PainelSecaoProgresso`.
export default {
  name: 'IntelligenceV2ChatMessagePlano',
  components: { PainelSecaoProgresso },
  props: {
    // `{itens: [{id, texto, estado}]}` já resolvido pelo pai (streaming vs
    // `message.plano` persistido) — este componente só exibe.
    itens: {
      type: Array,
      default: function() { return [] },
    },
    // Atalho do catálogo que abriu o turno (`/quem-migrar`) — vira "Usando skill /x".
    comando: {
      type: String,
      default: null,
    },
    // Turno em andamento: o ✦ gira. Parado, fica estático.
    ativo: {
      type: Boolean,
      default: false,
    },
    // Só a bolha DESTE turno encena. Sem isto, dois turnos com o mesmo plano
    // (`/panorama` repetido) têm a mesma assinatura e todos animam juntos.
    encenavel: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // `null` = segue o default (aberto). Clique manual vira override —
      // mesmo padrão do `ThinkingSteps` (`manualOpen`).
      manualOpen: null,
    }
  },
  computed: {
    mostrarPlano() {
      return this.itens.length > 0
    },
    planoAberto() {
      return this.manualOpen === null ? true : this.manualOpen
    },
    // O MESMO relógio do cartão flutuante (`utils/encenacao-do-plano.js`): as
    // duas superfícies desenham o mesmo plano lado a lado e não podem divergir.
    // Plano de OUTRA assinatura (histórico reaberto) nunca é encenado.
    itensExibidos() {
      const lista = this.itens || []
      if (!this.encenavel) return itensEncenados(lista, lista.length)
      const assinatura = assinaturaDePlano(lista.map((item) => item.texto))
      // `encenacaoDoPlano.revelados` entra na dependência do computed
      const revelados = encenacaoDoPlano.assinatura === assinatura
        ? reveladosDe(assinatura, lista.length)
        : lista.length
      return itensEncenados(lista, revelados)
    },
    passos() {
      return etapasDoPlano({ itens: this.itensExibidos })
    },
    titulo() {
      return this.comando ? PLANO_DO_TURNO.usandoSkill(this.comando) : PLANO_DO_TURNO.titulo
    },
    resumoDasEtapas() {
      const feitas = this.passos.filter((p) => p.status === STATUS_DO_PASSO.CONCLUIDA).length
      return PLANO_DO_TURNO.etapas(feitas, this.passos.length)
    },
  },
  methods: {
    togglePlano() {
      this.manualOpen = !this.planoAberto
    },
  },
}
</script>

<template>
  <div v-if="mostrarPlano" class="chat-message-plano mb-4">
    <button
      class="chat-message-plano__header d-flex align-center az-gap-small px-4 py-3 w-100 text-left"
      :aria-expanded="planoAberto ? 'true' : 'false'"
      @click="togglePlano"
    >
      <icon-svg
        name="ai-sparkle"
        :size="16"
        color="primary"
        class="chat-message-plano__icone flex-shrink-0"
        :class="{ 'chat-message-plano__icone--ativo': ativo }"
        data-test="plano-icone"
      />
      <span class="chat-message-plano__label az-text-primary az-size-14 font-weight-medium" data-test="plano-titulo">{{ titulo }}</span>
      <span class="az-text-secondary az-size-12 az-muted" data-test="plano-resumo">{{ resumoDasEtapas }}</span>
      <icon-svg
        name="arrow-down-light"
        :size="14"
        color="var(--neutral-600)"
        class="chat-message-plano__chevron"
        :class="{ 'chat-message-plano__chevron--expanded': planoAberto }"
      />
    </button>
    <div v-if="planoAberto" class="chat-message-plano__body px-4 py-3">
      <PainelSecaoProgresso :passos="passos" sem-titulo />
    </div>
  </div>
</template>

<style lang="sass" scoped>
.chat-message-plano
  border: 1px solid var(--border-hairline)
  border-radius: var(--radius-lg)
  background: var(--white)
  overflow: hidden

.chat-message-plano__header
  background: none
  border: none
  cursor: pointer

.chat-message-plano__label
  flex: 1

.chat-message-plano__body
  border-top: 1px solid var(--border-hairline)

.chat-message-plano__icone--ativo
  animation: chat-message-plano-giro 2.4s linear infinite

@keyframes chat-message-plano-giro
  to
    transform: rotate(360deg)

@media (prefers-reduced-motion: reduce)
  .chat-message-plano__icone--ativo
    animation: none

.chat-message-plano__chevron
  transition: transform var(--motion-duration-default) var(--motion-easing-standard)

.chat-message-plano__chevron--expanded
  transform: rotate(180deg)
</style>
